<template>
  <el-dialog
    class="dialog"
    title="设置组织"
    :visible.sync="dialogVisible"
    width="70%"
    destroy-on-close
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div class="main_container">
      <div class="left_content content_style">
        <el-input
          class="search-dept"
          prefix-icon="el-icon-search"
          v-model.trim="deptName"
          @input="searchDep"
          placeholder="请输入部门名称"
          clearable
        />
        <!-- 默认模式 -->
        <div class="main_content" v-if="!deptName">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="breadcrumb"
          >
            <el-breadcrumb-item
              v-for="(item, i) in breadcrumbList"
              :key="'bread' + i"
            >
              <span @click="checkBread(item)">{{ item.name }}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
          <div
            class="check_wrap"
            v-for="(item, i) in breadcrumbList"
            :key="'check_wrap' + i"
          >
            <el-checkbox
              :indeterminate="item.isIndeterminate"
              v-model="item.checkAll"
              @change="(v) => handleCheckAllChange(v, i)"
              v-if="i == curBreadIdx"
              >全选</el-checkbox
            >
            <el-checkbox-group
              v-model="defaultCheckedKeys"
              v-if="i == curBreadIdx"
            >
              <div class="check_list" v-if="!loading">
                <el-checkbox
                  v-for="dept in breadcrumbList[i].deptList"
                  :label="dept.uuid"
                  :key="dept.uuid"
                  @change="(v) => nodeChange(v, dept)"
                >
                  <span
                    v-if="
                      dept.hasChildren &&
                      !(defaultCheckedKeys.indexOf(dept.uuid) > -1)
                    "
                    @click="getNode(dept, i)"
                    >{{ dept.deptName }}</span
                  >
                  <span v-else>{{ dept.deptName }}</span>
                  <i
                    class="el-icon-arrow-right"
                    v-if="
                      dept.hasChildren &&
                      !(defaultCheckedKeys.indexOf(dept.uuid) > -1)
                    "
                    @click="getNode(dept, i)"
                  ></i>
                  <i
                    class="el-icon-arrow-right arrow_disable"
                    v-if="
                      dept.hasChildren &&
                      defaultCheckedKeys.indexOf(dept.uuid) > -1
                    "
                  ></i>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <!-- 搜索模式 -->
        <div class="main_content" v-if="!!deptName">
          <div class="check_wrap">
            <el-checkbox-group v-model="defaultCheckedKeys">
              <div class="check_list" v-if="!loading">
                <el-checkbox
                  v-for="dept in searchList"
                  :label="dept.uuid"
                  :key="dept.uuid"
                  @change="(v) => nodeChange(v, dept)"
                >
                  {{ dept.deptName }}
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="line_to_result"><i class="el-icon-arrow-right"></i></div>
      <div class="right_content content_style">
        <div class="results-title">
          <span class="closeall" @click="clearAll">清空</span
          ><span>已选组织({{ checkedEnrollDeptVos.length }})</span>
        </div>
        <div class="item-list-row">
          <div
            class="item-list-row-item"
            v-for="(item, i) in checkedEnrollDeptVos"
            :key="'EnrollDept' + i"
          >
            <span class="row-item-text">
              <span class="item-list-row-medium">{{ item.deptName }}</span>
            </span>
            <i
              class="el-icon-close del-icon"
              @click="removeNode(item, i, true)"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">取 消</el-button>
      <el-button type="primary" @click="selectDept" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { deptTreeForClass } from "@/api/dept";
import "../lineManage/dept.scss";
import { setOrgTagDept } from "@/api/user";
export default {
  props: ["showSetOrgModal"],
  data() {
    return {
      dialogVisible: false,
      deptName: "",
      breadcrumbList: [
        {
          name: "设置组织",
          index: 0,
          parentId: "0",
          deptList: [],
          checkAll: false,
          isIndeterminate: true,
        },
      ],
      curBreadIdx: 0,
      loading: false,
      searchList: [],
      checkedEnrollDeptVos: [],
    };
  },
  computed: {
    defaultCheckedKeys: {
      get() {
        return this.checkedEnrollDeptVos.map((ele) => ele.deptId);
      },
      set(v) {},
    },
  },
  created() {
    const _this = this;
    _this.dialogVisible = true;
    _this.getNode({}, null);
    if (_this.showSetOrgModal.enrollDeptVos) {
       _this.checkedEnrollDeptVos = JSON.parse(JSON.stringify(_this.showSetOrgModal.enrollDeptVos));
    }
  },
  methods: {
    closeDialog() {
      this.curBreadIdx = 0;
      this.breadcrumbList.splice(1);
      this.$emit("closeDialog", false);
    },
    // 全选
    handleCheckAllChange(val, index) {
      // 当前页数据
      this.breadcrumbList[index].isIndeterminate = false;
      let curCheckList = this.breadcrumbList[index].deptList || [];
      if (curCheckList.length > 0) {
        for (let i = 0; i < curCheckList.length; i++) {
          this.nodeChange(val, curCheckList[i], 1);
        }
      }
    },
    // 单选
    nodeChange(val, node, type) {
      let checkedEnrollDeptVos = this.checkedEnrollDeptVos.map(
        (ele) => ele.deptId
      );
      let idx = checkedEnrollDeptVos.indexOf(node.uuid);
      if (val) {
        // 当前选中已存在、返回；反之新增
        if (idx > -1) return;
        this.checkedEnrollDeptVos.unshift({
          deptId: node.uuid,
          deptName: node.deptName,
          parentId: node.parentId,
          deptLevelCode: node.deptLevelCode,
        });
      } else {
        // 当前选中已存在、删除；反之、返回
        if (idx > -1) {
          this.removeNode(node, idx);
        } else return;
      }
      if (type !== 1) {
        this.listenCheckAll(this.breadcrumbList[this.curBreadIdx].deptList);
      }
    },
    // 右边移除
    removeNode(item, i, checkAll) {
      this.checkedEnrollDeptVos.splice(i, 1);
      // 是否检查全选状态
      let deptList = this.breadcrumbList[this.curBreadIdx].deptList;
      let deptIdArr = deptList.map((ele) => ele.uuid);
      if (checkAll && deptIdArr.indexOf(item.deptId) > -1) {
        this.listenCheckAll(deptList);
      }
    },
    // 右边清空
    clearAll() {
      this.checkedEnrollDeptVos = [];
      // 清除全选
      for (let i = 0; i < this.breadcrumbList.length; i++) {
        this.breadcrumbList[i].isIndeterminate = false;
      }
    },
    // 切换面包屑
    checkBread(item) {
      this.curBreadIdx = item.index;
      this.breadcrumbList.splice(this.curBreadIdx + 1);
    },
    // 全选监听
    listenCheckAll(nodeList) {
      let checkedNum = 0;
      for (let i = 0; i < nodeList.length; i++) {
        if (this.defaultCheckedKeys.indexOf(nodeList[i].uuid) > -1) {
          checkedNum++;
        }
      }
      this.breadcrumbList[this.curBreadIdx].checkAll =
        checkedNum === nodeList.length;
      this.breadcrumbList[this.curBreadIdx].isIndeterminate =
        checkedNum > 0 && checkedNum < nodeList.length;
    },
    // 加载下级节点
    getNode(item, level) {
      this.loading = true;
      let params = {
        deptName: this.deptName,
        bNotAcrossDept: 1,
      };
      if (item.uuid) {
        params = { parentId: item.uuid };
      }
      if (level !== null) {
        this.curBreadIdx++;
        this.breadcrumbList[this.curBreadIdx] = {
          name: item.deptName,
          parentId: item.uuid,
          index: this.curBreadIdx,
          deptList: [],
          checkAll: false,
          isIndeterminate: true,
        };
      }
      deptTreeForClass(params).then((res) => {
        if (!res || res.code != 0) return;
        if (res.data.length > 0) {
          this.breadcrumbList[this.curBreadIdx].deptList = res.data;
          this.listenCheckAll(res.data);
        }
        this.loading = false;
      });
    },
    // 选择部门
    selectDept() {
      this.loading = true;
      let params = {
        lineId: this.showSetOrgModal.uuid,
        deptInnerDtoList: this.checkedEnrollDeptVos,
        confirm: '0'
      };
      this.loading = true;
      params.confirm = "1";
      setOrgTagDept(params).then((res) => {
        if (res && res.code == 0) {
          this.$message.success('操作成功');
          // 带上历史条件更新列表
          this.curBreadIdx = 0;
          this.breadcrumbList.splice(1);
          this.$emit("closeDialog", true);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    // 搜索
    searchDep(val) {
      this.searchList = [];
      this.loading = true;
      let params = {
        deptName: this.deptName,
        bNotAcrossDept: 1,
      };
      deptTreeForClass(params).then((res) => {
        if (!res || res.code != 0) return;
        if (res.data.length > 0) {
          this.searchList = res.data;
        }
        this.loading = false;
      });
    },
  },
};
</script>